<template>
  <transition name="fade">
    <div class="fixed-loader" v-if="isVisible">
      <div class="loader-container">
        <div class="logo-loader">
          <img src="@/assets/small_logo_dark.svg" alt="Logo" class="logo">
        </div>
        <!-- <div class="loader-text">טוען...</div> -->
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FixedLoader',
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    // Listen for events to show/hide the loader
    this.$bus.$on('show-loader', () => {
      this.isVisible = true;
    });
    
    this.$bus.$on('hide-loader', () => {
      this.isVisible = false;
    });
    
    // Toggle loader visibility
    this.$bus.$on('toggle-loader', () => {
      this.isVisible = !this.isVisible;
    });
  },
  beforeUnmount() {
    // Clean up event listeners
    this.$bus.$off('show-loader');
    this.$bus.$off('hide-loader');
    this.$bus.$off('toggle-loader');
  }
}
</script>

<style scoped>
.fixed-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(3px);
}

.loader-container {
  background-color: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  min-width: 150px;
}

.logo-loader {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.logo {
  width: 70px;
  height: 70px;
  position: relative;
  animation: spin 1.5s linear infinite;
}

.loader-text {
  font-size: 16px;
  font-weight: 500;
  color: #444444;
  margin-top: 5px;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>